import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

// eslint-disable-next-line no-magic-numbers
const ALLOWED_GRL_LEVELS = [1, 2, 3, 4, 5, 6];

@Pipe({
    name: "grlLevel",
})
export class GrlLevelPipe implements PipeTransform {
    constructor(private readonly translocoService: TranslocoService) {}

    public transform(grl: number | undefined): string | undefined {
        if (grl === undefined || grl === null) {
            return undefined;
        }

        return this.translocoService.translate("dtmUi.grlLabel", {
            grl: ALLOWED_GRL_LEVELS.includes(grl) ? grl : ALLOWED_GRL_LEVELS[ALLOWED_GRL_LEVELS.length - 1],
        });
    }
}

@Pipe({
    name: "controlledAreaGrlLevel",
})
export class ControlledAreaGrlLevelPipe implements PipeTransform {
    constructor(private readonly translocoService: TranslocoService) {}

    public transform(grl: number | undefined): string | undefined {
        if (grl === undefined || grl === null) {
            return undefined;
        }

        return this.translocoService.translate("dtmUi.controlledAreaGrlLabel", {
            grl: ALLOWED_GRL_LEVELS.includes(grl) ? grl : ALLOWED_GRL_LEVELS[ALLOWED_GRL_LEVELS.length - 1],
        });
    }
}
